import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ElomradePage = lazy(() => import("@/pages/elpriser/ElomradePage"));

export const Route = createFileRoute("/elpriser/elomrade-4")({
  head: () => seoHead("/elpriser/elomrade-4"),
  component: () => <ElomradePage />,
});
